"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorAlert = exports.ErrorAlert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const IError_1 = require("../../error/IError");
const Alert_1 = require("./Alert");
function ErrorAlert(_a) {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return jsx_runtime_1.jsx(Alert_1.Alert, Object.assign({}, props, { children: IError_1.printError(children) }), void 0);
}
exports.ErrorAlert = ErrorAlert;
function useErrorAlert(_a = { Component: ErrorAlert }) {
    var { Component } = _a, props = tslib_1.__rest(_a, ["Component"]);
    const error = props.children || undefined;
    const [errorAlert, setErrorAlert] = react_1.useState(error);
    if (!Component) {
        Component = ErrorAlert;
    }
    return {
        errorAlert: errorAlert ? jsx_runtime_1.jsx(Component, Object.assign({}, props, { children: errorAlert }), void 0) : null,
        setErrorAlert: (alert) => {
            setErrorAlert(alert);
        },
    };
}
exports.useErrorAlert = useErrorAlert;
//# sourceMappingURL=ErrorAlert.js.map